import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import {
  VOTER_SEARCH_API_CONSTANTS,
  VOTER_SEARCH_CONFIG_CONSTANTS,
} from "../../constants/api.constant";
import { VOTER_SEARCH_API_LOCATION_CONSTANT } from "../../constants/location.constant";
import { IN_VoterInterface } from "../../Interfaces/voter-data.interface";
import {
  IN_AddFamilyMember,
  IN_DeleteById,
  IN_SearchByAge,
  IN_SearchByAlphabet,
  IN_SearchByEdu,
  IN_SearchByLastName,
  IN_SearchByName,
  IN_SearchByOccupation,
  IN_SearchBySurname,
  IN_SearchByWild,
  IN_VoterSearchByGeneralReq,
  IN_VoterSearchByPhoneReq,
  IN_VoterSearchByVoterIdReq,
} from "../../Interfaces/voter-search.Interface";
import { PAGE_CONFIG } from "src/app/common/constant/pageconfig.constant";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class VoterSearchAPIService {
  constructor(private http: HttpClient) {}

  private sharedDataSubject = new BehaviorSubject<string>('Initial Value');
  sharedData$ = this.sharedDataSubject.asObservable();

  updateSharedData(data: string) {
    this.sharedDataSubject.next(data);
  }
  
  public getSearchResultListConfig() {
    return this.http.get(
      `${VOTER_SEARCH_API_CONSTANTS.SEARCH_RESULT_TABLE_CONFIG}`
    );
  }

  public getSurnameListConfig() {
    return this.http.get(
      `${VOTER_SEARCH_CONFIG_CONSTANTS.SURNAME_TABLE_CONFIG}`
    );
  }

  public getSearchResultListSearchViewConfig() {
    return this.http.get(
      `${VOTER_SEARCH_API_CONSTANTS.SEARCH_RESULT_TABLE_CONFIG_SEARCH_VIEW}`
    );
  } 

  public getHistorySearchListSearchViewConfig() {
    return this.http.get(
      `${VOTER_SEARCH_API_CONSTANTS.SEARCH_HISTORY_TABLE_CONFIG_SEARCH_VIEW}`
    );
  }
  public searchByVoterId(payload: IN_VoterSearchByVoterIdReq) {
    return this.http.post(
      `${VOTER_SEARCH_API_CONSTANTS.SEARCH_BY_VOTER_ID}`,
      payload
    );
  }
  public searchByPhone(payload: IN_VoterSearchByPhoneReq) {
    return this.http.post(
      `${VOTER_SEARCH_API_CONSTANTS.SEARCH_BY_PHONE}`,
      payload
    );
  }

  public searchByGeneral(payload: IN_VoterSearchByGeneralReq) {
    return this.http.post(
      `${VOTER_SEARCH_API_CONSTANTS.SEARCH_BY_GENERAL}`,
      payload
    );
  }

  public createVoterData(payload: IN_VoterInterface) {
    return this.http.post(`${VOTER_SEARCH_API_CONSTANTS.VOTOR_DATA}`, payload);
  }

  public getCast() {
    return this.http.get(`${VOTER_SEARCH_API_CONSTANTS.CAST}`);
  }

  public getAssemblyData() {
    return this.http.get(
      `${VOTER_SEARCH_API_LOCATION_CONSTANT.ASSEMBLIES_LIST}`
    );
  }

  public getGaonData(assemblyId: any) {
    return this.http.get(
      `${VOTER_SEARCH_API_LOCATION_CONSTANT.GAON_LIST}/${assemblyId}`
    );
  }
  public getGaonDataWithAssembly(assemblyId: any) {
    return this.http.get(
      `${VOTER_SEARCH_API_LOCATION_CONSTANT.GAON_LIST_WITH_ASSEMBLY}/${assemblyId}`
    );
  }

  public getGatNumberData(gatId: any) {
    return this.http.get(
      `${VOTER_SEARCH_API_LOCATION_CONSTANT.GATNO_LIST}/${gatId}`
    );
  }

  public getGanNumberData(ganId: any) {
    return this.http.get(
      `${VOTER_SEARCH_API_LOCATION_CONSTANT.GAN_NUMBER_LIST}/${ganId}`
    );
  }

  public getPrabhagData(prabhagId: any) {
    return this.http.get(
      `${VOTER_SEARCH_API_LOCATION_CONSTANT.PRABHAG_LIST}/${prabhagId}`
    );
  }

  public getPrabhagAreaData(prabhagAreaId: any) {
    return this.http.get(
      `${VOTER_SEARCH_API_LOCATION_CONSTANT.PRABHAG_AREA_LIST}/${prabhagAreaId}`
    );
  }

  //NVSF
  public searchByDefault(payload: IN_SearchByWild) {
    return this.http.post(
      `${VOTER_SEARCH_API_CONSTANTS.VOTER_SEARCH}`,
      payload
    );
  }

  public searchByName(payload: IN_SearchByName) {
    return this.http.post(
      `${VOTER_SEARCH_API_CONSTANTS.VOTER_SEARCH}`,
      payload
    );
  }

  public export(payload) {
    return this.http.post(`${VOTER_SEARCH_API_CONSTANTS.VOTER_SEARCH_EXPORT}`, payload, { headers: { Accept: "application/pdf" }, responseType: "blob" });
    // return this.http.post(
    //   `${VOTER_SEARCH_API_CONSTANTS.VOTER_SEARCH_EXPORT}`,
    //   payload
    // );
  }

  public searchByAlphabet(payload: IN_SearchByAlphabet) {
    return this.http.post(
      `${VOTER_SEARCH_API_CONSTANTS.VOTER_SEARCH}`,
      payload
    );
  }

  public searchByAge(payload: IN_SearchByAge) {
    return this.http.post(
      `${VOTER_SEARCH_API_CONSTANTS.VOTER_SEARCH}`,
      payload
    );
  }

  public searchByWild(payload: IN_SearchByWild) {
    return this.http.post(`${VOTER_SEARCH_API_CONSTANTS.WILD_SEARCH}`, payload);
  }

  public searchByEdu(payload: IN_SearchByEdu) {
    return this.http.post(
      `${VOTER_SEARCH_API_CONSTANTS.VOTER_SEARCH}`,
      payload
    );
  }

  public searchByOcc(payload: IN_SearchByOccupation) {
    return this.http.post(
      `${VOTER_SEARCH_API_CONSTANTS.VOTER_SEARCH}`,
      payload
    );
  }

  public searchBySurname(payload: IN_SearchBySurname) {
    return this.http.post(
      `${VOTER_SEARCH_API_CONSTANTS.VOTER_SEARCH}`,
      payload
    );
  }

  public getBoothData() {
    return this.http.get(`${VOTER_SEARCH_API_CONSTANTS.BOOTH_NAME_DATA}?boothName=null`);
  }

  public initSurnameListData(params) {
    return this.http.get(
      `${VOTER_SEARCH_API_CONSTANTS.INIT_SURNAME_DATA}/${params}`
    );
  }

  public getPageConfig() {
    return this.http.get(PAGE_CONFIG.Volunteer_Page);
  }
  // public voterSearchConfig(id) {
  //   return this.http.post(`${VOTER_SEARCH_API_CONSTANTS.VOTER_SEARCH_API_CONFIG}/${id}`
  //   );
  // }
  public getFamilyMember(memberID:any){
    return this.http.get(`${VOTER_SEARCH_API_CONSTANTS.GET_FAMILY_MEMBER}/${memberID}`)
  }

  public getVisitorForEdit(memberID:any){
    return this.http.get(`${VOTER_SEARCH_API_CONSTANTS.VOTOR_DATA}/${memberID}`)
  }

  public updateRecord(payload:any){
    return this.http.put(`${VOTER_SEARCH_API_CONSTANTS.VOTOR_DATA}/${payload.id}`,payload)
  }

  public removeFamilyMember(payload:IN_DeleteById) {
    return this.http.post(`${VOTER_SEARCH_API_CONSTANTS.REMOVE_FAMILY_MEMBER}`,payload);
  }
  public addFamilyMember(payload:IN_AddFamilyMember){
    return this.http.post(`${VOTER_SEARCH_API_CONSTANTS.ADD_FAMILY_MEMBER}`,payload)
  }
  


  public getVoterConfig() {
    return this.http.get(`${VOTER_SEARCH_API_CONSTANTS.VOTER_SEARCH_API_CONFIG}/1`);
  }

  public updateVoterConfig(payload) {
    return this.http.post(VOTER_SEARCH_API_CONSTANTS.VOTER_SEARCH_API_CONFIG,payload);
  }

  public publicSearchHistory(payload) {
    return this.http.post(VOTER_SEARCH_API_CONSTANTS.VOTER_PUBLIC_SEARCH_HISTORY_API,payload);
  }
  public downloadExcelSearchHistory(){
    return this.http.post(VOTER_SEARCH_API_CONSTANTS.DOWNLOAD_EXCEL_SEARCH_HISTORY,{},{ headers: { Accept: "application/pdf" }, responseType: "blob" });
  }
}
